import { Link } from "react-router-dom";
import { WarningIcon } from "@phosphor-icons/react";

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <div
        data-testid="not-found"
        className="max-w-md w-full bg-white border border-slate-200 rounded-lg p-10 text-center shadow-card"
      >
        <WarningIcon size={32} weight="duotone" className="mx-auto text-amber-600" />
        <div className="text-[11px] uppercase tracking-wider text-slate-500 mt-3 font-semibold">
          Error 404
        </div>
        <h1 className="font-heading text-3xl font-bold text-slate-900 mt-1">
          Page not found
        </h1>
        <p className="text-sm text-slate-600 mt-2 leading-relaxed">
          That route doesn't exist in Zion Solar Service OS yet.
        </p>
        <Link
          data-testid="go-home"
          to="/"
          className="mt-6 inline-flex items-center justify-center rounded-md bg-slate-900 px-4 py-2.5 text-[13px] font-semibold text-white hover:bg-slate-800 transition-colors"
        >
          Back to Dashboard
        </Link>
      </div>
    </div>
  );
}
